module.exports = __webpack_public_path__ + "static/assets/0ba23a9a5c91a5e95ad8c73567f8cf63.png";